import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import config from "../../../../config/apiConfig";
import Loader from "react-spinners/RingLoader";

const StoryDetails: React.FC<{ id: string }> = ({ id }) => {
    const [story, setStory] = useState<{ [key: string]: any }>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL + "/v1/get/story/" + id + "?climit=1000",
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                setStory(resp);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return <Loader color={"pink"} />;
    }

    return (
        <React.Fragment>
            <h4 className="story__header">{story?.data[0]?.title}</h4>
            <p style={{ fontSize: "16px", lineHeight: "1.56" }}>
                {story?.data[0]?.description}
            </p>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                    src={story?.data[0]?.images[0]?.link}
                    className="story__img"
                />
            </div>
            <p
                style={{
                    fontSize: "16px",
                    margin: "26px 24px 24px 0px",
                    lineHeight: "1.56",
                }}
                dangerouslySetInnerHTML={{ __html: story?.data[0]?.body }}
            ></p>
            <button
                className="read__button"
                onClick={(e) => {
                    e.preventDefault();
                    const win = window.open(story?.data[0].url, "_blank");
                    win?.focus();
                }}
            >
                Read full article
            </button>
        </React.Fragment>
    );
};

export default StoryDetails;
